<template>
  <div class="theme">
    <div class="theme__image">
      <img :src="imageUrl" alt="Onboarding Theme" />
    </div>
    <div class="theme__header" v-html="title"></div>
    <div class="theme__caption" v-html="subTitle"></div>
    <div class="theme__action">
      <div class="theme__action--left">
        <i class="fas fa-moon"></i>
        Dark
      </div>
      <div class="theme__action--center">
        <ButtonSwitch
          true-value="light"
          false-value="dark"
          :default-value="objUserSetting.theme"
          @changed-value="onSelectItem"
          :data-action="dataAction"
          data-eventcategory="app_onboard_flow"
        />
      </div>
      <div class="theme__action--right">
        <i class="fas fa-sun"></i>
        Light
      </div>
    </div>
  </div>
</template>

<script>
import { ButtonSwitch } from "../../atoms"
export default {
  components: {
    ButtonSwitch
  },
  props: {
    title: {
      type: String,
      default: "มืดหรือสว่าง",
      required: false
    },
    subTitle: {
      type: String,
      default: "เลือกการแสดงผลที่คุณชอบ",
      required: false
    },
    arrData: {
      type: Array,
      default: function() {
        return []
      }
    },
    objUserSetting: {
      type: Object,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      dataAction: 'toggle_light'
    }
  },
  computed: {
    imageUrl() {
      let path = `${process.env.VUE_APP_SCONTENT_URL}/line-liff/onboarding`
      let fileName = `onboarding-theme@3x.png`
      if (this.objUserSetting.theme === "dark") return `${path}/dark/${fileName}`
      else return `${path}/${fileName}`
    }
  },
  methods: {
    onSelectItem(val) {
      val === 'dark' ? this.dataAction = 'toggle_dark' :  this.dataAction = 'toggle_light'
      this.$emit("callback-func", val)
      document.documentElement.setAttribute("data-theme", val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/_OnboardingTheme";
</style>